import { render, staticRenderFns } from "./InformasiKaryawan.vue?vue&type=template&id=25595d9a&"
import script from "./InformasiKaryawan.vue?vue&type=script&lang=js&"
export * from "./InformasiKaryawan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports